import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Account } from "services";
import { ModelsActions } from "store/actions";
import { ecommerce_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import { Summary } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const AccountDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { account_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.account);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    reload();

    // eslint-disable-next-line
  }, [account_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const reload = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Account.detail(account_id);
      dispatch(ModelsActions.update_model({ account: model }));
    }).finally(() => setLoading(false));
  }

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
  ];

  if (!tab) {
    return <Redirect to={`/accounts/${account_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Account.del(account_id);
      router.history.push('/accounts');
    }).finally(() => mounted && setLoading(false));
  }

  return (
    <AuthGuard roles={[ecommerce_manager]} projects={[]}>
      <Page className={classes.root} title="Account Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.displayname} header="Account" subtitle={model.reference} />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary handleDelete={handleDelete} reload={reload} />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

AccountDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default AccountDetail;
